import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["overlay"]

  open() {
    this.overlayTarget.classList.remove("hidden")
    document.addEventListener("keydown", this.handleEscape)
  }

  close() {
    this.overlayTarget.classList.add("hidden")
    document.removeEventListener("keydown", this.handleEscape)
  }

  handleEscape = (event) => {
    if (event.key === "Escape") this.close()
  }

  disconnect() {
    document.removeEventListener("keydown", this.handleEscape)
  }
}
